<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.activity_show,
                    },
                    {
                        name: $tc('messages.questions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex space-x-2">
            <div>
                <aside class="justify-self-center">
                    <nav
                        class="inline-flex items-center justify-center p-1 space-x-1 overflow-hidden text-sm text-gray-600 bg-gray-100 rounded-xl"
                    >
                        <template v-for="link in meta.menu.links" :key="link.url">
                            <template v-if="link.selected">
                                <AppButton :href="link.url" element="inertia-link">
                                    {{ link.display_name }}
                                </AppButton>
                            </template>
                            <template v-else>
                                <InertiaLink
                                    :href="link.url"
                                    class="inline-flex items-center h-8 px-5 font-medium transition rounded-lg hover:text-gray-800 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                                >
                                    {{ link.display_name }}
                                </InertiaLink>
                            </template>
                        </template>
                    </nav>
                </aside>
            </div>
        </div>

        <div class="flex space-x-2 mt-1">
            <div>
                <aside class="justify-self-center">
                    <nav
                        class="inline-flex flex-wrap items-center justify-center p-1 space-x-1 overflow-hidden text-sm text-gray-600 bg-gray-100 rounded-xl"
                    >
                        <template v-for="link in meta.links.adaptations" :key="link.url">
                            <AppButton as="inertia-link" :href="link.url" v-if="link.is_selected">
                                {{ link.text }}
                            </AppButton>
                            <inertia-link
                                v-else
                                :href="link.url"
                                class="inline-flex items-center h-8 px-5 font-medium transition rounded-lg hover:text-gray-800 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                            >
                                {{ link.text }}
                            </inertia-link>
                        </template>
                    </nav>
                </aside>
            </div>
        </div>

        <div class="" v-if="activity.image_path">
            <div class="mt-1">
                <img :src="activity.image_path" alt="cover" class="h-auto" />
            </div>
        </div>

        <div class="" v-if="activity.accompanying_text">
            <div class="mt-1">
                <p v-html="activity.accompanying_text" class="prose" />
            </div>
        </div>

        <div v-if="activity.materials.length > 0" class="mt-3 md:mt-5">
            <div>
                {{ $tc('messages.materials', 2) }}
            </div>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-12">
                    <ul class="">
                        <li v-for="(row, index) in activity.materials" :key="index" class="list-disc">
                            <span v-if="!row.url">
                                {{ row.title }}
                            </span>
                            <a :href="row.url" target="_blank" class="text-indigo-500" v-else>
                                <svg
                                    class="w-4 h-4 inline-block"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                                    ></path>
                                    <path
                                        d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                                    ></path>
                                </svg>
                                <span class="truncate text-ellipsis overflow-hidden">
                                    {{ row.title ? row.title : row.url }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <QuizReview
            :activity="activity"
            :questions="quiz.questions"
            :students="quiz.students"
            :mode="quiz.mode"
            v-if="quiz"
        />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import QuizReview from '@/components/QuizReview.vue';

export default {
    components: {
        QuizReview,
        PanelPage,
        AppButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'activity', 'quiz'],
    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {},
};
</script>
